import { isRecord } from '@/helpers/isRecord'

import { TransportationOption, TransportationOptionResource } from './TransportationOption'

export const transformToTransportationOptions = (items: TransportationOptionResource[]): TransportationOption[] => items.map(resource => ({
    id: resource.id,
    name: resource.attributes.name,
}))

// The v3 API returns plain JSON (not JSON:API): an array of `{ id, name }`. Returns undefined for any other response.
export const transformV3ResponseToTransportationOptions = (data: unknown): TransportationOption[] | undefined => {
    if (! Array.isArray(data)) {
        return undefined
    }

    return data.filter(isRecord).map(option => ({
        id: String(option.id),
        name: String(option.name),
    }))
}
